module.exports = __webpack_public_path__ + "img/drop.658472e9.svg";